import React, { useState } from "react";
import {
	Container,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Col,
	Button,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
} from "reactstrap";
import { Link } from "react-router-dom";

const SignUp = (props) => {
	const [form, setForm] = useState({});
	function handleChange(event) {
		const target = event.target;
		const value = target.checked ? target.checked : target.value;
		const name = target.name;
		setForm({
			...form,
			[name]: value,
		});
	}
	function handleSubmit(event) {
		event.preventDefault();
		console.log(form);
	}
	const validatePassword = () => {
		console.log(form);
		if (!form?.password) {
			return false;
		} else if (form.password && !form?.confirmPassword) {
			return false;
		} else if (form.password && form.confirmPassword) {
			if (form.password === form.confirmPassword) {
				return false;
			} else {
				return true;
			}
		}
	};
	return (
		<Container>
			<Form onChange={handleChange} onSubmit={handleSubmit}>
				<Card style={{ maxWidth: 600, margin: "auto", marginTop: 16 }}>
					<CardHeader>
						<h3>SignUp for City@UMD Access</h3>
					</CardHeader>
					<CardBody>
						<FormGroup row>
							<Label for="exampleEmail" xs={12} sm={4}>
								Email
							</Label>
							<Col xs={12} sm={8}>
								<Input type="email" name="email" id="exampleEmail" />
							</Col>
						</FormGroup>
						<FormGroup row>
							<Label for="examplePassword" xs={12} sm={4}>
								Password
							</Label>
							<Col xs={12} sm={8}>
								<Input
									type="password"
									name="password"
									id="examplePassword"
									placeholder="Password"
								/>
							</Col>
						</FormGroup>
						<FormGroup row>
							<Label for="confirmPassword" xs={12} sm={4}>
								Confirm Password
							</Label>
							<Col xs={12} sm={8}>
								<Input
									type="password"
									name="confirmPassword"
									id="confirmPassword"
									placeholder="Confirm Passowrd"
									invalid={validatePassword()}
								/>
							</Col>
						</FormGroup>
					</CardBody>
					<CardFooter
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
						}}
					>
						<Button color="link" tag={Link} to="/user/login">
							Already Have Account? Login.
						</Button>
						<Button type="submit">SignUp</Button>
					</CardFooter>
				</Card>
			</Form>
		</Container>
	);
};

export default SignUp;
